
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Console } from '@angular/core/src/console';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { GlobalProvider } from '../global/global';
import { LogProvider } from '../log/log';

/*
  Generated class for the PonentesProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class DocumentosProvider {

  //private api: string = "http://www.app-congreso.com/ws_appmicongreso/api/";
  private api: string;
  constructor(public http: Http, public global: GlobalProvider, public log:LogProvider) {
    this.api = this.global.api;
  
  }



  // Elimina un documento
  public delete(ndocumento): Observable<any> {
   
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros = {
      "token": this.global.token,
      "tabla": "documentos",
      "clave": ndocumento,
    };

    return this.http.post(this.api + "apigen/delete.php", parametros, options).map(
      (response) => {
        return response.json();
      }
    ).catch(this.handleError);
  }

  // Inserta un congreso nuevo
  public insert(congreso, documento): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    documento.clavecongreso = congreso.clave;

    let parametros = {
      "token": this.global.token,
      "clavecongreso": documento.clavecongreso,
      "tabla": "documentos",
      "parametros": documento
    };

    
    return this.http.post(this.api + "documentos/inserta_documento.php", parametros, options).map(
      (response) => {
        return response.json();
      }
    ).catch(this.handleError);
  }

  // Inserta un congreso nuevo
  public update(congreso, documento): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros = {
      "token": this.global.token,
      "clavecongreso": documento.clavecongreso,
      "clave": documento.clave,
      "parametros": documento
    };
  console.log(parametros);
    return this.http.post(this.api + "documentos/edita_documento.php", parametros, options).map(
      (response) => {
       // var respuesta = response.json();
     return '';
        //return respuesta[0];
      }
    ).catch(this.handleError);
  }



  // Devuelve todos los poenentes de un congreso
  /*public documentosprograma(claveprograma): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros ={
      "token":this.global.token,
      "tabla":"documentos",
      "campofiltro":"claveprograma",
      "valorfiltro": claveprograma
    };
    console.log("documentos provider", parametros);
    return this.http.post(this.api+"apigen/list.php", parametros, options).map(
      (response) => {
        console.log("devuelve documentos", response);
        return response.json();
        
      }
    ).catch(this.handleError);
  }*/
  public documentosprograma(claveprograma): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "claveprograma": claveprograma
    };
  
    return this.http.post(this.api + "programa/documentosprograma.php", parametros, options).map(
      (response) => {
      
        return response.json();

      }
    ).catch(this.handleError);
  }

  // Devuelve todos los poenentes de un congreso
  public all(clavecongreso): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "clavecongreso": clavecongreso
    };
   
    return this.http.post(this.api + "documentos/listadocumentos.php", parametros, options).map(
      (response) => {
              
        return response.json();

      }
    ).catch(this.handleError);
  }
  public alletiqueta(clavecongreso, etiqueta): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "clavecongreso": clavecongreso,
      "etiqueta": etiqueta
    };
    
    
   return this.http.post(this.api + "documentos/listadocumentosetiqueta.php", parametros, options).map(
      (response) => {
      
        return response.json();

      }
    ).catch(this.handleError);
  }
  public updateestado(documento): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros ={
      "token":this.global.token,
      "tabla": "documentos",
      "clave": documento.clave,
      "parametros": documento
    };
    console.log(parametros);
   
    return this.http.post(this.api+"apigen/update.php", parametros, options).map(
      (response) => {
        var respuesta = response.json();
         
         return respuesta[0];
      }
    ).catch(this.handleError);
  }

  private handleError(error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// ./src/providers/documentos/documentos.ts